import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Dimmer,
  Icon,
  Loader,
  Segment,
  Tab,
  TabPane
} from 'semantic-ui-react';
import CompactModeSection from '../../../components/shared/CompactModeSection';
import CompactModeToggle from '../../../components/shared/CompactModeToggle';
import ProfessionalFigure from '../../../components/shared/ProfessionalFigure';
import {
  addActualForecastProfessionalFigure,
  deleteActualForecastProfessionalFigure,
  setActualForecastDetails,
  setActualForecastProfessionalFigure,
  setFinancialDataModalOpen,
  startGetActualForecastDetails,
  startGetAreas,
  startGetBudgetDetails,
  startGetBudgetProfessionalFigures,
  startGetCompanies,
  startGetExchangeRates,
  startGetInternalLevels,
  startGetProfessionalFiguresActualForecast,
  startGetSalesLevels
} from '../../../store/actions/shared/professionalFigures';
import { groupFiguresByLevel, getDefaultCollapsedKeys } from '../../../utils/professionalFigureUtils';
import { getDatesAndYears, isBudgetT0ReadOnly, thereIsOnlyOneFunction } from '../../../utils/projectPlanningUtils';
import NextCostsAndRevenuesT0Modal from './NextCostsAndRevenuesT0Modal';
import NextOverviewModal from './NextOverviewModal';


function BudgetT0NextEditServiceContainer(props) {
  // console.log("BudgetT0NextEditServiceContainer ~ props:", props)
  const budget_id = props.budget_id

  const [activePane, setActivePane] = useState(0);
  const [activeInnerPane, setActiveInnerPane] = useState(0);
  const [isCompactMode, setIsCompactMode] = useState(false);
  const [collapsedSections, setCollapsedSections] = useState({ '__invalid_area__': true });

  const toggleSection = (key) => {
    setCollapsedSections(prev => ({ ...prev, [key]: !prev[key] }))
  }

  const isReadOnly = isBudgetT0ReadOnly(props.budget.status)
  const useBudgetValues = props.budget.status === "confirmed" || props.budget.status === "change requested"

  const getFiguresArray = () => {
    return useBudgetValues ? props.budgetProfessionalFigures : props.actualForecastProfessionalFigures
  }

  const handleToggleCompactMode = () => {
    setIsCompactMode(prev => {
      const nextMode = !prev
      if (nextMode) {
        var figures = getFiguresArray()
        var internalGroups = groupFiguresByLevel(figures, 0)
        var externalGroups = groupFiguresByLevel(figures, 1)
        var defaultCollapsed = Object.assign(
          {},
          getDefaultCollapsedKeys(internalGroups),
          getDefaultCollapsedKeys(externalGroups)
        )
        setCollapsedSections(defaultCollapsed)
      }
      return nextMode
    })
  }

  useEffect(() => {
    props.getCompanies()
    props.getSalesLevels(props.budget.project_id)
    props.getInternalLevels()
    props.getAreas()
    props.getExchangeRates()
    if (useBudgetValues) {
      props.getBudgetProfessionalFigures(budget_id, new Date(props.budget.start_date), new Date(props.budget.end_date))
      props.getBudgetDetails(budget_id, new Date(props.budget.start_date), new Date(props.budget.end_date))
    } else {
      props.getProfessionalFiguresActualForecast(budget_id)
      props.getActualForecastDetails(budget_id, new Date(props.budget.start_date), new Date(props.budget.end_date))
    }

  }, [])

  const { startDate, endDate, numberOfYears, years } = getDatesAndYears(props.budget)

  const superCutoffDate = props.cutoffs.find(x => x.is_super_cutoff) !== undefined
    ? new Date(props.cutoffs.find(x => x.is_super_cutoff).to_date)
    : new Date();

  const closingDate = !props.budget.closing_date ? null : new Date(props.budget.closing_date)

  const theOneRing = thereIsOnlyOneFunction(startDate, endDate, superCutoffDate, undefined, closingDate)

  const onAddProfessionalFigure = () => {
    props.addProfessionalFigure(startDate, endDate, activeInnerPane === 1, props.budget.currency_code)
  }

  const onDeleteProfessionalFigure = (index) => {
    props.deleteProfessionalFigure(index)
  }

  const onChangeInnerTab = (_event, data) => {
    setActiveInnerPane(data.activeIndex)
  }

  const onTabChange = (_event, data) => {
    setActivePane(data.activeIndex)
    setActiveIndex(data.activeIndex)
  }

  const [activeIndex, setActiveIndex] = useState(0);

  const professionalFigures = useBudgetValues ? props.budgetProfessionalFigures : props.actualForecastProfessionalFigures
  // console.log("professionalFigures ~ professionalFigures:", professionalFigures)


  const menuItemClass = activeInnerPane === 0 ? 'menu-item-active' : 'menu-item'

  const menuItemClassExternal = activeInnerPane !== 0 ? 'menu-item-active' : 'menu-item'

  const styleBottomAddFigure = { display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', backgroundColor: '#f1f4f5', border: '2px dashed#607c89', padding: '2rem', opacity: '0.6', width: '100%' }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%', width: '100%' }}>
      <Dimmer active={props.loading} inverted>
        <Loader indeterminate inverted content="Loading" size="medium" />
      </Dimmer>

      <Tab
        onTabChange={onTabChange}
        style={{ overflowY: 'auto', height: '100vh' }}
        menu={{
          attached: true, tabular: true,
          style: {
            position: 'sticky',
            top: '0',
            left: '0',
            zIndex: '123456',
            backgroundColor: '#f1f4f5',
            height: '6.2rem',
            justifyContent: "flex-start",
            alignItems: "flex-start"
          }
        }}
        panes={
          years.map((year, index) => ({
            menuItem: {
              content: year.toString(),
              className: activeIndex === index ? 'menu-item-active' : 'menu-item'
            },
            render: () => (
              <>
              <CompactModeToggle
                isCompact={isCompactMode}
                onToggle={handleToggleCompactMode}
                fixed
              />
              <Tab
                onTabChange={onChangeInnerTab}
                menu={{
                  attached: true, tabular: true,
                  style: {
                    position: 'fixed',
                    height: '3.08rem',
                    backgroundColor: '#f1f4f5',
                    top: '7.24rem',
                    borderBottom: 0,
                    zIndex: '123456',
                    boxSizing: 'border-box',
                    width: "50%"
                  }
                }}
                panes={[
                  {
                    menuItem: {
                      content: (
                        <>
                          <Icon name='sign-in' />
                          Internal Figures ({professionalFigures.filter(x => x.external === 0).length})
                        </>
                      ),
                      className: menuItemClass
                    },
                    render: () => {
                      // Creare un contatore per le figure interne
                      let internalCount = 0;
                      const internalGroups = isCompactMode
                        ? groupFiguresByLevel(professionalFigures, 0)
                        : null;

                      return (
                        <TabPane style={{ backgroundColor: '#f1f4f5', border: '0', paddingTop: '0.1rem' }}>
                          {!isCompactMode && professionalFigures.map((x, i) => {
                            if (x.external === 0) {
                              internalCount++;

                              const isFirstInternal = i === professionalFigures.findIndex(y => y.external === 0);

                              return (
                                <ProfessionalFigure
                                  key={i}
                                  options={props.options}
                                  year={year}
                                  values={x}
                                  setValues={(properties) => props.setProfessionalFigure(i, properties)}
                                  onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(i)}
                                  pfeOrBudget={props.budget}
                                  documentType="t0"
                                  theOneRing={theOneRing}
                                  isReadOnly={isReadOnly}
                                  style={isFirstInternal ? {} : {}}
                                  iterationNumber={internalCount}
                                />
                              );
                            }
                            return null;
                          })}
                          {isCompactMode && internalGroups.groups.map(group => (
                            <CompactModeSection
                              key={group.key}
                              groupKey={group.key}
                              label={group.label}
                              count={group.figures.length}
                              collapsed={!!collapsedSections[group.key]}
                              onToggle={toggleSection}
                            >
                              {!internalGroups.isHierarchical && group.figures.map(({ index, figure }, groupIdx) => (
                                <ProfessionalFigure
                                  key={index}
                                  options={props.options}
                                  year={year}
                                  values={figure}
                                  setValues={(properties) => props.setProfessionalFigure(index, properties)}
                                  onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(index)}
                                  pfeOrBudget={props.budget}
                                  documentType="t0"
                                  theOneRing={theOneRing}
                                  isReadOnly={isReadOnly}
                                  style={{}}
                                  iterationNumber={groupIdx + 1}
                                />
                              ))}
                              {internalGroups.isHierarchical && group.subgroups.map(sub => (
                                <CompactModeSection
                                  key={sub.key}
                                  groupKey={group.key + '_' + sub.key}
                                  label={sub.label}
                                  count={sub.figures.length}
                                  collapsed={!!collapsedSections[group.key + '_' + sub.key]}
                                  onToggle={toggleSection}
                                  nested
                                >
                                  {sub.figures.map(({ index, figure }, subIdx) => (
                                    <ProfessionalFigure
                                      key={index}
                                      options={props.options}
                                      year={year}
                                      values={figure}
                                      setValues={(properties) => props.setProfessionalFigure(index, properties)}
                                      onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(index)}
                                      pfeOrBudget={props.budget}
                                      documentType="t0"
                                      theOneRing={theOneRing}
                                      isReadOnly={isReadOnly}
                                      style={{}}
                                      iterationNumber={subIdx + 1}
                                    />
                                  ))}
                                </CompactModeSection>
                              ))}
                            </CompactModeSection>
                          ))}
                          {isCompactMode && internalGroups.invalidAreaGroup && (
                            <CompactModeSection
                              key={internalGroups.invalidAreaGroup.key}
                              groupKey={internalGroups.invalidAreaGroup.key}
                              label={internalGroups.invalidAreaGroup.label}
                              count={internalGroups.invalidAreaGroup.figures.length}
                              collapsed={collapsedSections[internalGroups.invalidAreaGroup.key] !== false}
                              onToggle={toggleSection}
                            >
                              {!internalGroups.invalidAreaGroup.isHierarchical && internalGroups.invalidAreaGroup.subgroups.map(sub => (
                                <CompactModeSection
                                  key={sub.key}
                                  groupKey={'ia_' + sub.key}
                                  label={sub.label}
                                  count={sub.figures.length}
                                  collapsed={!!collapsedSections['ia_' + sub.key]}
                                  onToggle={toggleSection}
                                  nested
                                >
                                  {sub.figures.map(({ index, figure }, subIdx) => (
                                    <ProfessionalFigure
                                      key={index}
                                      options={props.options}
                                      year={year}
                                      values={figure}
                                      setValues={(properties) => props.setProfessionalFigure(index, properties)}
                                      onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(index)}
                                      pfeOrBudget={props.budget}
                                      documentType="t0"
                                      theOneRing={theOneRing}
                                      isReadOnly={isReadOnly}
                                      style={{}}
                                      iterationNumber={subIdx + 1}
                                    />
                                  ))}
                                </CompactModeSection>
                              ))}
                              {internalGroups.invalidAreaGroup.isHierarchical && internalGroups.invalidAreaGroup.subgroups.map(companyGroup => (
                                <CompactModeSection
                                  key={companyGroup.key}
                                  groupKey={'ia_' + companyGroup.key}
                                  label={companyGroup.label}
                                  count={companyGroup.figures.length}
                                  collapsed={!!collapsedSections['ia_' + companyGroup.key]}
                                  onToggle={toggleSection}
                                  nested
                                >
                                  {companyGroup.subgroups.map(sub => (
                                    <CompactModeSection
                                      key={sub.key}
                                      groupKey={'ia_' + companyGroup.key + '_' + sub.key}
                                      label={sub.label}
                                      count={sub.figures.length}
                                      collapsed={!!collapsedSections['ia_' + companyGroup.key + '_' + sub.key]}
                                      onToggle={toggleSection}
                                      nested
                                    >
                                      {sub.figures.map(({ index, figure }, subIdx) => (
                                        <ProfessionalFigure
                                          key={index}
                                          options={props.options}
                                          year={year}
                                          values={figure}
                                          setValues={(properties) => props.setProfessionalFigure(index, properties)}
                                          onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(index)}
                                          pfeOrBudget={props.budget}
                                          documentType="t0"
                                          theOneRing={theOneRing}
                                          isReadOnly={isReadOnly}
                                          style={{}}
                                          iterationNumber={subIdx + 1}
                                        />
                                      ))}
                                    </CompactModeSection>
                                  ))}
                                </CompactModeSection>
                              ))}
                            </CompactModeSection>
                          )}
                          {isCompactMode && internalGroups.newFigures.map(({ index, figure }, newIdx) => (
                            <ProfessionalFigure
                              key={index}
                              options={props.options}
                              year={year}
                              values={figure}
                              setValues={(properties) => props.setProfessionalFigure(index, properties)}
                              onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(index)}
                              pfeOrBudget={props.budget}
                              documentType="t0"
                              theOneRing={theOneRing}
                              isReadOnly={isReadOnly}
                              style={{}}
                              iterationNumber={newIdx + 1}
                            />
                          ))}
                          {!isReadOnly &&
                            <Segment style={styleBottomAddFigure} onClick={onAddProfessionalFigure}>
                              <Icon name='users' size='large' style={{ marginRight: '0.5rem' }} />
                              <strong>Click on "Add Internal Professional Figure" to add a new one.</strong>
                            </Segment>
                          }
                        </TabPane>
                      );
                    }
                  },
                  {
                    menuItem: {
                      content: (
                        <>
                          <Icon name='sign-out' />
                          External Figures ({professionalFigures.filter(x => x.external === 1).length})
                        </>
                      ),
                      className: menuItemClassExternal
                    },
                    render: () => {
                      // Creare un contatore per le figure esterne
                      let externalCount = 0;
                      const externalGroups = isCompactMode
                        ? groupFiguresByLevel(professionalFigures, 1)
                        : null;

                      return (
                        <TabPane style={{ backgroundColor: '#f1f4f5', border: '0', paddingTop: '0.1rem' }}>
                          {!isCompactMode && professionalFigures.map((x, i) => {
                            if (x.external === 1) {
                              externalCount++;

                              const isFirstExternal = i === professionalFigures.findIndex(y => y.external === 1);

                              return (
                                <ProfessionalFigure
                                  key={i}
                                  options={props.options}
                                  year={year}
                                  values={x}
                                  setValues={(properties) => props.setProfessionalFigure(i, properties)}
                                  onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(i)}
                                  pfeOrBudget={props.budget}
                                  documentType="t0"
                                  theOneRing={theOneRing}
                                  isReadOnly={isReadOnly}
                                  style={isFirstExternal ? {} : {}}
                                  iterationNumber={externalCount}
                                />
                              );
                            }
                            return null;
                          })}
                          {isCompactMode && externalGroups.groups.map(group => (
                            <CompactModeSection
                              key={group.key}
                              groupKey={group.key}
                              label={group.label}
                              count={group.figures.length}
                              collapsed={!!collapsedSections[group.key]}
                              onToggle={toggleSection}
                            >
                              {!externalGroups.isHierarchical && group.figures.map(({ index, figure }, groupIdx) => (
                                <ProfessionalFigure
                                  key={index}
                                  options={props.options}
                                  year={year}
                                  values={figure}
                                  setValues={(properties) => props.setProfessionalFigure(index, properties)}
                                  onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(index)}
                                  pfeOrBudget={props.budget}
                                  documentType="t0"
                                  theOneRing={theOneRing}
                                  isReadOnly={isReadOnly}
                                  style={{}}
                                  iterationNumber={groupIdx + 1}
                                />
                              ))}
                              {externalGroups.isHierarchical && group.subgroups.map(sub => (
                                <CompactModeSection
                                  key={sub.key}
                                  groupKey={group.key + '_' + sub.key}
                                  label={sub.label}
                                  count={sub.figures.length}
                                  collapsed={!!collapsedSections[group.key + '_' + sub.key]}
                                  onToggle={toggleSection}
                                  nested
                                >
                                  {sub.figures.map(({ index, figure }, subIdx) => (
                                    <ProfessionalFigure
                                      key={index}
                                      options={props.options}
                                      year={year}
                                      values={figure}
                                      setValues={(properties) => props.setProfessionalFigure(index, properties)}
                                      onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(index)}
                                      pfeOrBudget={props.budget}
                                      documentType="t0"
                                      theOneRing={theOneRing}
                                      isReadOnly={isReadOnly}
                                      style={{}}
                                      iterationNumber={subIdx + 1}
                                    />
                                  ))}
                                </CompactModeSection>
                              ))}
                            </CompactModeSection>
                          ))}
                          {isCompactMode && externalGroups.newFigures.map(({ index, figure }, newIdx) => (
                            <ProfessionalFigure
                              key={index}
                              options={props.options}
                              year={year}
                              values={figure}
                              setValues={(properties) => props.setProfessionalFigure(index, properties)}
                              onDeleteProfessionalFigure={() => onDeleteProfessionalFigure(index)}
                              pfeOrBudget={props.budget}
                              documentType="t0"
                              theOneRing={theOneRing}
                              isReadOnly={isReadOnly}
                              style={{}}
                              iterationNumber={newIdx + 1}
                            />
                          ))}
                          {!isReadOnly &&
                            <Segment style={styleBottomAddFigure} onClick={onAddProfessionalFigure}>
                              <Icon name='users' size='large' style={{ marginRight: '0.5rem' }} />
                              <strong>Click on "Add External Professional Figure" to add a new one.</strong>
                            </Segment>
                          }
                        </TabPane>
                      );
                    }
                  }
                ]}
              />
              </>
            )
          }
          ))
        }
      />
      {/* </div> */}

      <NextOverviewModal
        isOpen={props.overview}
        onClose={() => props.setOverview(false)}
        professionalFigures={professionalFigures}
        pfeOrBudget={props.budget}
        theOneRing={theOneRing}
        isPfe={false}
      />

      {props.isFinancialDataModalOpen &&
        <NextCostsAndRevenuesT0Modal
          isOpen={props.isFinancialDataModalOpen}
          onClose={() => props.setFinancialDataModalOpen(false)}
          figures={professionalFigures}
          actual_forecast_details={useBudgetValues ? props.budget_details : props.actual_forecast_details}
          setValues={props.setActualForecastDetails}
          budget={props.budget}
          theOneRing={theOneRing}
          isReadOnly={isReadOnly}
        />}

    </div>
  )
}


const mapStateToProps = state => ({
  loading: state.professionalFiguresReducer.loading_budget ||
    state.professionalFiguresReducer.loadingCompanies ||
    state.professionalFiguresReducer.loadingInternalLevels ||
    state.professionalFiguresReducer.loadingAreas ||
    state.professionalFiguresReducer.loadingSalesLevels ||
    state.professionalFiguresReducer.loadingExchangeRates ||
    state.professionalFiguresReducer.loading_actual_forecast_details ||
    state.professionalFiguresReducer.loading_budget_details ||
    state.professionalFiguresReducer.loadingProfessionalFigures ||
    state.professionalFiguresReducer.loading_budget_figures,

  budget: state.professionalFiguresReducer.budget.find(b => b.status_type === "t0"),

  isFinancialDataModalOpen: state.professionalFiguresReducer.isFinancialDataModalOpen,
  financialData: state.professionalFiguresReducer.financialData,
  actual_forecast_details: state.professionalFiguresReducer.actual_forecast_details,
  budget_details: state.professionalFiguresReducer.budget_details,

  actualForecastProfessionalFigures: state.professionalFiguresReducer.actualForecastProfessionalFigures,
  budgetProfessionalFigures: state.professionalFiguresReducer.budgetProfessionalFigures,

  cutoffs: state.cutoffReducer.cutoff_pm === undefined ? [] : state.cutoffReducer.cutoff_pm,

  options: {
    companies: _.toArray(
      _.mapValues(_.filter(state.professionalFiguresReducer.companies, { 'active': 1 }), c => {
        return {
          key: c.id,
          value: c.code,
          text: c.name,
          country_code: c.country_code,
          currency_code: c.currency_code,
        };
      })
    ),
    internalLevels: state.professionalFiguresReducer.internalLevels,
    areas: state.professionalFiguresReducer.areas,
    salesLevels: _.toArray(
      _.mapValues(state.professionalFiguresReducer.salesLevels, s => {
        return {
          key: s.code,
          value: s.code,
          text: s.name,
          daily_rate: s.daily_rate
        }
      })
    ),
    exchangeRates: state.professionalFiguresReducer.exchangeRates,
  }
});

const mapDispatchToProps = dispatch => {
  return {

    getCompanies: () => dispatch(startGetCompanies()),
    getInternalLevels: () => dispatch(startGetInternalLevels()),
    getAreas: () => dispatch(startGetAreas()),
    getSalesLevels: (project_id) => dispatch(startGetSalesLevels(project_id)),
    getExchangeRates: () => dispatch(startGetExchangeRates()),

    setFinancialDataModalOpen: (isOpen) => dispatch(setFinancialDataModalOpen(isOpen)),
    setActualForecastDetails: (year, month, properties) => dispatch(setActualForecastDetails(year, month, properties)),
    getActualForecastDetails: (budgetId, startDate, endDate) => dispatch(startGetActualForecastDetails(budgetId, startDate, endDate)),
    getBudgetDetails: (budgetId, startDate, endDate) => dispatch(startGetBudgetDetails(budgetId, startDate, endDate)),

    getProfessionalFiguresActualForecast: (budget_id) => dispatch(startGetProfessionalFiguresActualForecast(budget_id)),
    getBudgetProfessionalFigures: (budget_id, startDate, endDate) => dispatch(startGetBudgetProfessionalFigures(budget_id, startDate, endDate)),
    setProfessionalFigure: (index, properties, superCutoffDate) => dispatch(setActualForecastProfessionalFigure(index, properties, superCutoffDate)),
    deleteProfessionalFigure: (index) => dispatch(deleteActualForecastProfessionalFigure(index)),
    addProfessionalFigure: (startDate, endDate, isExternal, currency_code) => dispatch(addActualForecastProfessionalFigure(startDate, endDate, isExternal, currency_code)),
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BudgetT0NextEditServiceContainer);
